import {
  formDataRequest,
  getRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceEmailComposerCreate(params) {
  return await formDataRequest("email/composer/send", params);
}
export async function serviceEmailComposerDetail(params) {
  return await formDataRequest("email/composer/detail", params);
}
export async function serviceEmailComposerList(params) {
  return await formDataRequest("email/composer", params);
}
export async function serviceEmailUsers(params) {
  return await formDataRequest("email/composer/get/send/to", params);
}
export async function serviceRecipientLists(params) {
  return await formDataRequest("email/composer/get/read/updates", params);
}
export async function serviceDownloadRecipientLists(params) {
  return await formDataRequest("email/composer/reciepents/export", params);
}
export async function serviceImageUploader(params) {
  return await formDataRequest('files/upload', params,{"folder": "uploaded_files"});
}
export async function serviceEmailComposerSampleCsv(params) {
  return await getRequest('email/composer/sample/csv', params);
}
export async function serviceEmailComposerVerifyCsv(params) {
  return await formDataRequest('email/composer/verify/csv', params);
}